import React from "react";
import { Drawer, Divider, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountUser from "./account/AccountUser";
import ListNavegation from "./ListNavegation";
import useIsMobile from "../utils/hooks/useIsMobile";
import Logo from "../utils/Logo";

export default function DrawerNavbar({ handleDrawerToggle, mobileOpen }) {
  const isMobile = useIsMobile();
  const drawerWidth = isMobile ? "100%" : "23%";

  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      open={mobileOpen}
      anchor="left"
      BackdropProps={{ invisible: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "lightBlue.main",
          border: "none",
        },
      }}
    >
      <Grid
        container
        direction="column"
        sx={{ height: "100%", padding: "10px 20px" }}
      >
        <Grid
          item
          xs={isMobile ? 0.5 : 1}
          alignSelf={isMobile && "flex-end"}
          sx={{ display: "flex" }}
        >
          {isMobile ? (
            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          ) : (
            <AccountUser />
          )}
        </Grid>

        <Divider sx={{ mt: 2, mb: 2 }} />

        <Grid item xs={8}>
          <ListNavegation handleDrawerToggle={handleDrawerToggle} />
        </Grid>

        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Logo width={"90px"} />
        </Grid>
      </Grid>
    </Drawer>
  );
}
